var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-round pull-right btn-book",class:[{'btn-rose': !_vm.status.disabled}],attrs:{"disabled":!!_vm.status.disabled}},[_vm._v(_vm._s(_vm.status.text))])}
var staticRenderFns = []

export { render, staticRenderFns }